// const API = "http://192.168.1.135:3700/api";
const API = "https://back.maac.edu.pe/api";
export default API;
